<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Źródło',
              modelPath: [this, 'form', 'source'],
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Treść',
              modelPath: [this, 'form', 'content'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
